/* global StripeCheckout */

import React from 'react'
import RaisedButton from 'material-ui/RaisedButton'
import CheckCircle from 'material-ui/svg-icons/action/check-circle'
import { green500 } from 'material-ui/styles/colors'

import config from '../../config'
const { stripePublishableKey, stripeBillingEmail } = config

class Stripe extends React.Component<any, any> {
  componentWillMount () {
// @ts-ignore
    this.checkoutHandler = StripeCheckout.configure({
      key: stripePublishableKey,
      locale: 'auto',
      token: token => {
        this.props.onChange(null, token.id)
      }
    })
  }

  handleCheckoutButtonClick = e => {
// @ts-ignore
    this.checkoutHandler.open({
      email: stripeBillingEmail,
      name: 'NCFDD Admin',
      description: 'Create Payment',
      allowRememberMe: false
    })
    e.preventDefault()
  }

  componentWillUnmount () {
// @ts-ignore
    this.checkoutHandler.close()
  }

  render () {
    const { value } = this.props

    return (
      <RaisedButton
        onClick={this.handleCheckoutButtonClick}
        label='Create Stripe Charge'
        labelPosition='before'
        icon={value && <CheckCircle color={green500} />}
      />
    )
  }
}

// @ts-ignore
Stripe.propTypes = {
  onChange: React.PropTypes.func.isRequired,
  value: React.PropTypes.string
}

export default Stripe
